<script lang="ts" setup></script>

<template>
  <ul class="sm:border border-slate-200 shadow-sm sm:rounded-lg sm:divide-y sm:divide-slate-200">
    <slot />
  </ul>
</template>
